<template>
  <div class="content">
    <h3 ref="pageHeader" :style="{'--width': widthVar}"  class="pageHeader">安全隐患列表</h3>
    <div>
      <el-form :inline="true" :model="formInline" class="demo-form-inline" label-position="left">
        <el-form-item label="组织结构">
          <OrganDialog ref="organDia1" @getSelect="getSelect1" :level="levell" @handleOrganQuery="handleOrganQuery1"></OrganDialog>
          <el-input v-model="organLabel" placeholder="请选择组织结构" style="width:320px;" @focus="dialogOpen1" @clear="handeleClear1" clearable></el-input>
        </el-form-item>
        <el-form-item :label="`${$store.state.themeTitle}室名称`">
          <el-select v-model="formInline.training_room" clearable filterable :placeholder="`请选择${$store.state.themeTitle}室名称`">
            <el-option v-for="item in $store.state.trainRooms" :key="item.id" :label="item.training_name" :value="item.training_name"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="隐患状态">
          <el-select v-model="formInline.trouble_status"  filterable placeholder="请选择隐患状态">
            <el-option v-for="item in $store.state.troubleStatus" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="实训项目">
          <el-input v-model="formInline.train_name" clearable placeholder="请输入实训项目"></el-input>
        </el-form-item> -->
        <!-- <el-form-item label="创建人">
          <el-input v-model="formInline.teacher" clearable placeholder="请输入创建人"></el-input>
        </el-form-item> -->
        <el-form-item>
          <el-button type="primary" @click="handleQuery">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="downloadFile">导出安全隐患自查自纠汇总表</el-button>
        </el-form-item>
        <!-- <el-form-item>
          <el-button type="primary" @click="handleAdd()">新建</el-button>
        </el-form-item> -->
        <!-- <el-form-item>
          <el-button type="primary" @click="handleExport">{{exportTitle}}</el-button>
        </el-form-item> -->
        <!-- <el-form-item>
          <el-button type="primary" @click="handlePrint">打印</el-button>
        </el-form-item> -->
      </el-form>
    </div>
    <div>
      <custom-table :data="tableData" ref="table" border style="width: 100%">
        <custom-table-column fixed prop="record_name" label="检查名称" width="160">
        </custom-table-column>
        <custom-table-column prop="record_item_name" label="检查内容" min-width="220">
        </custom-table-column>
        <custom-table-column label="整改状态" width="100" prop="trouble_status"  label-class-name="troubleStatus" :formatter="format_arr">
        </custom-table-column>
        <custom-table-column prop="structure_1" label="院系" width="160">
        </custom-table-column>
        <custom-table-column prop="training_room_name" :label="`${$store.state.themeTitle}室`" width="180">
        </custom-table-column>
        <custom-table-column fixed="right" label="操作" width="140">
          <template slot-scope="scope">
            <el-button @click="handleDetailClick(scope.row)" type="text" size="small">详情</el-button>
            <el-button @click="handleAdd(scope.row.id)" type="text" size="small">整改结果提交</el-button>
            <!-- <el-button @click="handleDelet(scope.row.id)" type="text" size="small">删除</el-button> -->
          </template>
        </custom-table-column>
      </custom-table>
      <div class="pageLine">
        <PageLine :total='total' ref="pageChild" @getList="getList"></PageLine>
      </div>
    </div>
    <el-dialog :close-on-click-modal="false" :title="title" :visible.sync="centerDialogVisible" width="546px">
      <OrganDialog ref="organDia" @getSelect="getSelect" :level="levell1" @handleOrganQuery="handleOrganQuery"></OrganDialog>
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="120px" class="demo-ruleForm">
        <el-form-item label="整改情况描述" prop="rectify_desc">
          <el-input type="textarea" v-model="ruleForm.rectify_desc" placeholder="请选择整改情况描述" :rows="6" style="width:352px;"></el-input>
        </el-form-item>
        <el-form-item label="整改图片上传" prop="rectify_file" style="width:100%">
            <Uploadd ref="uploadd" :action="action" :params="params" @setFileList="setUpFileList" @delFile="delUpFile" :btnTitle="btnTitle" :uploadType="uploadType"></Uploadd>
        </el-form-item>
        <el-form-item style="margin-top:8px;width:100%;text-align:right;">
          <el-button type="primary" v-if="type=='add'" @click="submitFormByFun('ruleForm',createMethod)">确认</el-button>
          <el-button type="primary" v-if="type=='edit'" @click="submitFormByFun('ruleForm',updateMethod)">编辑</el-button>
          <el-button @click="resetForm('ruleForm')" style="margin-right:24px;">重置</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog :close-on-click-modal="false" title="提示" :visible.sync="dialogVisible" width="400px">
      <span>是否删除</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="deleteMethod">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog :close-on-click-modal="false" title="详情" :visible.sync="detailDialogVisible" width="746px">
      <el-descriptions class="margin-top" title="" direction="vertical" :column="2"  border>
        <el-descriptions-item>
          <template slot="label">检查内容 </template> {{rowObj.name}}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">状态 </template>
          <span v-if="rowObj.rectify_status=='1'" style="color:var(--blue);">评估</span>
          <span v-if="rowObj.rectify_status=='2'" style="color:var(--ligtGreen);">整改</span>
          <span v-if="rowObj.rectify_status=='3'" style="color:var(--red);">验证</span>
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">隐患等级 </template> {{rowObj.level}}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">分值 </template> {{rowObj.score}}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">整改期限 </template> {{rowObj.rectify_limit_date}}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">整改图片</template>
          <!-- <template v-if="rowObj.file">
            <el-link type="primary" v-for="(item,index) in rowObj.file.split(',')" :href="item" :key="index" target="_blank">{{ $until.getFileName(item) }}</el-link>
          </template> -->
          <template  v-if="rowObj.file">
            <el-image v-for="(item,index) in rowObj.file.split(',')" :key="index" :src="item" :preview-src-list="rowObj.file.split(',')"  style="width: 60px; height: 60px;margin-right: 4px;">
            </el-image>
          </template>
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">问题描述 </template> {{rowObj.desc}}
        </el-descriptions-item>
      </el-descriptions>
    </el-dialog>
  </div>
</template>

<script>
import { mixinList } from '@/assets/js/mixin/list';
import { mixinOrgan } from '@/assets/js/mixin/organization';
import { mixinImport } from '@/assets/js/mixin/import';
import { mixinUpload } from '@/assets/js/mixin/upload';
import { mixinFormatter } from '@/assets/js/mixin/formatter';

export default {
  name: 'trainingRoom',
  mixins: [mixinList, mixinOrgan,mixinUpload,mixinImport,mixinFormatter],
  data() {
    return {
      classRooms: [],
      detailDialogVisible: false,
      rowObj: {},
      formInline: {
        structure_1: '',
        training_room: '',
        trouble_status: 0,
      },
      btnTitle:'点击上传隐患图片',
      uploadType:'image',
      levell: [1],
      levell1: [1, 2, 3],
      selectName: '',
      organLabel: '',
      ruleForm: {
        rectify_desc: '',
        rectify_file: '',
      },
      rules: {
        rectify_file: [{ required: true, message: '请上传附件' }],
        rectify_desc: [{ required: true, message: '请输入设备使用情况', trigger: 'blur' }],
      },
      type: 'add',
      title: '新增',
      tableName: '实训日志',
      fileFieldName: 'rectify_file', //表名
      troubleId:null,
      downloadUrl: '',
      downloadName: '安全隐患自查自纠汇总表.xlsx',
    };
  },
  created() {
    this.downloadUrl=`api/safety_check/trouble_sum/export`
  },
  mounted() {
    // this.getList();
    this.$store.dispatch('getTarinMent');
  },
  methods: {
    onSubmit() {
      console.log('submit!');
    },
    handleDetailClick(row) {
      this.rowObj = row.source_info;
      this.detailDialogVisible = true;
    },
    handleAdd(id) {
      this.type = 'add'
      this.title = "提交申请"
      if (this.selectName) {
        this.selectName = ''
      }
      this.ruleForm = this.$until.easyDeepCopy(this.ruleFormTep)
      this.centerDialogVisible = true;
      this.$nextTick(() => {
        if (this.$refs.ruleForm) {
          this.$refs.ruleForm.clearValidate()
        }
      });
      this.troubleId = id
    },
    async getTarinMent() {
      let res = await this.$api.instance.getTarinMent();
      if (res.code == 0) {
        this.classRooms = res.data;
      }
    },
    handleClassChange(e) {
      // this.ruleForm.room_id = e.id
      this.ruleForm.room_name = this.$until.getLabelName(this.$store.state.trainRooms, 'id', 'training_name', e);
    },
    handleSet() {
      this.centerDialogVisible = true;
    },
    handleClick() {
      this.centerDialogVisible = true;
    },
    handleBack() {
      this.$message.info('撤销中。。。');
    },
    handlePrint() {
      this.$message.info('打印中。。。');
    },
    async deleteMethod() {
      let params = { id: this.delid };
      let res = await this.$api.delet.deleteMethod(params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '删除成功！',
        });
        this.dialogVisible = false;
        this.handleQuery();
      }
    },
    async createMethod() {
      let params = this.$until.deleteNullPrototype(this.ruleForm);
      let res = await this.$api.instance.interfaceServer(`api/safety_check/trouble/rectify/apply/${this.troubleId}`, 'post', params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '提交成功！',
        });
        this.clearState();
      }
    },
    async updateMethod() {
      let params = this.$until.easyDeepCopy(this.ruleForm);;
      let res = await this.$api.update.updateMethod(params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '编辑成功！',
        });
        this.clearState();
      }
    },
    getOrganList() {
      this.tableData1 = [];
      console.log(this.ruleForm);
      if (this.selectNode.level == 3) {
        this.selectName = this.selectNode.structure_names || this.selectNode.name;
        let strArr = this.selectNode.structure_names.split('-');
        this.ruleForm.structure_1 = strArr[0];
        this.ruleForm.major = strArr[1];
        this.ruleForm.class = strArr[2];
      }
      if (!this.selectName) {
        this.ruleForm.structure_1 = '';
        this.ruleForm.major = '';
        this.ruleForm.class = '';
      }

      // this.ruleForm.type_value = this.selectNode.structure_ids;
      // this.organs = [this.selectNode];
    },
    handleQuery() {
      this.beforeQuery();
      this.$refs.pageChild.page = 1;
      this.getList();
    },
    async getList() {
      let params = this.$until.deleteNullPrototype(this.formInline);
      params.page = this.$refs.pageChild.page;
      params.size = this.$refs.pageChild.size;
      let res = await this.$api.instance.interfaceServer('api/safety_check/trouble/list', 'get', params);
      if (res.code == 0 && res.data) {
        this.tableData = res.data.data;
        this.total = res.data.total;
      }
    },
  },
};
</script>
<style lang="less" scoped>
.pageHeader:before {
  width: var(--width);
}
/deep/.el-link {
  margin-right: 4px;
}
</style>
